<script lang="ts">
import { defineComponent } from 'vue';
import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
dayjs.extend(updateLocale);

dayjs.updateLocale('en', {
  weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
});

export default defineComponent({
  name: 'DatePicker',
  props: {
    selectedDate: {
      type: String,
      required: true,
    },
    format: {
      type: String,
      default: 'MM/DD/YYYY',
    },
  },
  data() {
    return {
      datepickerVisible: false,
      dateWorkFormat: 'YYYY-MM-DD',
      weekDayNames: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    };
  },
  computed: {
    formattedDate() {
      const weekDay = this.$dayjs(this.selectedDate).day();
      return `${this.$dayjs(this.selectedDate).format(this.format)} ${this.weekDayNames[weekDay]}`;
    },
  },
  methods: {
    updateSelectedDate(newDate) {
      this.datepickerVisible = false;
      const dateToReturn = this.$dayjs(newDate).format(this.dateWorkFormat);
      this.$emit('update-date', dateToReturn);
    },
  },
});
</script>

<template>
  <v-menu
      v-model="datepickerVisible"
      :close-on-content-click="false"
  >
    <template #activator="{ props }">
      <v-btn
          v-bind="props"
          class="mr-2"
          color="white"
          variant="flat"
      >
        <v-icon>mdi-calendar-blank</v-icon>
        <span>{{ formattedDate }}</span>
      </v-btn>
    </template>

    <v-date-picker style="width: 100%" @update:model-value="updateSelectedDate"></v-date-picker>
  </v-menu>
</template>
